/* script */



























































import Vue from 'vue';
import Component from 'vue-class-component';

@Component({ props: ['add-friends-url', 'appeal-text', 'appeal-image-url'] })
class FaceModalComponent extends Vue {
    addFriendsUrl!: string;
    appealText!: string;
    appealImageUrl!: string;
}
const __vue_script__ = FaceModalComponent;

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "line-modal" } }, [
    _c("div", { staticClass: "line-modal-header" }, [
      _c("h1", [_vm._v("LINE公式アカウント")]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "control",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v("close")]
      ),
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "line-modal-body" }, [
      _vm.appealImageUrl
        ? _c(
            "div",
            {
              staticClass: "image-container",
              staticStyle: { height: "16rem" },
            },
            [_c("img", { attrs: { src: _vm.appealImageUrl } })]
          )
        : _c("div", { staticClass: "line-default-banner" }, [
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
          ]),
      _vm._v(" "),
      _c("pre", { staticClass: "scrollable" }, [
        _vm._v(_vm._s(_vm.appealText)),
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "line-modal-button",
          attrs: { href: _vm.addFriendsUrl },
        },
        [_vm._v("友だち追加する")]
      ),
    ]),
  ])
}
var __vue_staticRenderFns__ = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("div", { staticClass: "dots" }, [
        _c("p"),
        _vm._v(" "),
        _c("p"),
        _vm._v(" "),
        _c("p"),
        _vm._v(" "),
        _c("p"),
        _vm._v(" "),
        _c("p"),
        _vm._v(" "),
        _c("p"),
        _vm._v(" "),
        _c("p"),
        _vm._v(" "),
        _c("p"),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("h4", [_vm._v("友だち追加しておトクな情報を受け取ろう!")]),
        _vm._v(" "),
        _c("h2", [_vm._v("LINE公式アカウント特別情報")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "dots" }, [
        _c("p"),
        _vm._v(" "),
        _c("p"),
        _vm._v(" "),
        _c("p"),
        _vm._v(" "),
        _c("p"),
        _vm._v(" "),
        _c("p"),
        _vm._v(" "),
        _c("p"),
        _vm._v(" "),
        _c("p"),
        _vm._v(" "),
        _c("p"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left-box" }, [
      _c("h1", [_vm._v("LINE")]),
      _vm._v(" "),
      _c("h1", [_vm._v("公式アカウント")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right-box" }, [
      _c("h1", [_vm._v("友だち追加で")]),
      _vm._v(" "),
      _c("p", [_vm._v("お得な特典いっぱい！")]),
    ])
  },
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "script_src/register/LineModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__